<nav>
  <ng-content></ng-content>
</nav>
